export enum NotificationType {
    AwaitingAcceptanceOrder = 'orders.orderAwaitingAcceptance',
    AcceptedOrder = 'orders.orderAccepted',
    PostponedOrder = 'orders.orderPostponed',
    PrintKitchenBon = 'print.printKitchenBon',
    PrintDeliveryTicket = 'print.printDeliveryTicket',
    PrintReceipt = 'print.printReceipt',
    PrintOpenTabSubmissionBon = 'print.printOpenTabSubmissionBon',
    PrintShiftCloseout = 'print.printShiftCloseout',
}
